import React from 'react';

export default props => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="8.066" height="5.097" viewBox="0 0 8.066 5.097" className={props.className}>
            <path id="Path_492" data-name="Path 492" d="M1160,1232l3.61,3.852,3.61-3.852" transform="translate(1167.643 1236.7) rotate(180)" fill="none" stroke={props.link ? "#2E8142" : "#1f1f1f"} strokeWidth="1.16"/>
        </svg>
    );
}


